var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgP = function SvgP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 45",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#418FDE",
    d: "M0 18.133v26h18.267v-26H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BDFF",
    d: "M18.133 0C8.133 0 0 8.133 0 18.133h18.267v18.134c9.933-.067 18-8.134 18-18.134C36.2 8.133 28.133 0 18.133 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#005BE0",
    d: "M0 18.133c0 5 2 9.534 5.333 12.8 3.267 3.267 7.8 5.334 12.8 5.334h.134V18.133H0Z"
  })));
};
export default SvgP;